<template>
    <div class="simple-search-result">
        <div class="simple-search-result__inner">
            <a :href="`/node/${result.nid}`" class="simple-search-result__title-link">
                <div class="simple-search-result__meta">
                    <span v-if="type" class="simple-search-result__type">{{ type }}</span>
                    <span v-if="formattedDate" class="simple-search-result__date">
                    {{ formattedDate }}
                    </span>
                </div>
              <div v-html="highlight(result.title)" class="simple-search-result__title"></div>
              <div v-if="matchedResult.matchedWords.length" class="simple-search-result__excerpt" v-html="matchedResult.value"></div>
              <div v-else-if="result.field_concert_intro" v-html="highlight(trim(result.field_concert_intro, 80, true))" class="simple-search-result__excerpt"></div>
              <div v-else-if="result.field_intro" v-html="highlight(trim(result.field_intro, 80, true))" class="simple-search-result__excerpt"></div>
              <div v-else-if="result.body" v-html="highlight(trim(result.body, 80, true))" class="simple-search-result__excerpt"></div>
              <div v-else-if="result.artist_title" v-html="highlight(trim(result.artist_title, 80, true))" class="simple-search-result__excerpt"></div>
            </a>
        </div>
    </div>
</template>

<script src="./SimpleSearchResult.js"></script>
<style src="./SimpleSearchResult.scss" lang="scss"></style>
